const paths = {
    home: '/',
    reviewCatalog: '/reviews',
    review: '/reviews',
};

export default paths;
